import script from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ChartDataEditor.vue?vue&type=style&index=0&id=4a4f61ef&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4f61ef"]])

export default __exports__